import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { InstagramMediaDto } from '../models/instagram/instagrammedia-dto';

@Injectable({
  providedIn: 'root'
})
export class InstagramService {

  constructor(private apiService: ApiService) { }

  getMediaCollection(): Observable<InstagramMediaDto[]> {
    return this.apiService.get<InstagramMediaDto[]>(`Instagram/media`);
  }
}
